var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.modifiers),function(modifier){return _c('h-description',{key:modifier.id,attrs:{"name":modifier.name,"price":modifier.price * _vm.quantity,"paid":_vm.paid}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }